import { Actions } from './Actions'
import { SelectAction, SelectObj } from './interfaces'

export function reducer(state: SelectObj, action: SelectAction): SelectObj {
  switch (action.type) {
    case Actions.Selected:
      if (state.mode === 'single') {
        return {
          ...state,
          selectedItem: action.item,
          selectedItemDisplayText: action.displayText,
        }
      } else {
        // TODO: Add selectedItemDisplayText for multiselect
        if (!state.selectedItem) {
          return { ...state, selectedItem: [action.item] }
        } else if (state.selectedItem.includes(action.item)) {
          return {
            ...state,
            selectedItem: state.selectedItem.filter((i) => i !== action.item),
          }
        } else {
          return {
            ...state,
            selectedItem: [...state.selectedItem, action.item],
          }
        }
      }

    default:
      throw new Error()
  }
}
